import dayjs from 'dayjs'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import translations from '@translationKeys'

import { Box, FormControl, InputLabel, Typography } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { colors } from '@theme/variables'

import { MINIMUM_DATE_RANGE_BOUND_DATE } from './constants'

export interface CustomDateRangePickerProps {
  start?: string
  end?: string
  onDateChange: (start?: string, end?: string) => void
}

export const CustomDateRangePicker = ({ start, end, onDateChange }: CustomDateRangePickerProps) => {
  const { t } = useTranslation()
  const [localStartDate, setLocalStartDate] = useState(start)
  const [localEndDate, setLocalEndDate] = useState(end)

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box display="flex" alignItems="center" marginTop="-8px" gap="5px">
        <FormControl sx={{ minWidth: '80px' }} variant="outlined" margin="normal">
          <InputLabel
            sx={{ background: colors.white, padding: '0 6px', color: '#00000099' }}
            data-testid="shortlist-filter-combination-label"
            shrink
          >
            {t(translations.START)}
          </InputLabel>
          <DatePicker
            sx={{ width: '145px' }}
            slotProps={{
              openPickerButton: {
                sx: { marginRight: 0 },
                size: 'small',
              },
            }}
            format="DD/MM/YYYY"
            value={start ? dayjs(start) : null}
            onChange={newStartDate => {
              if (newStartDate?.isValid() && newStartDate.year() >= MINIMUM_DATE_RANGE_BOUND_DATE.getFullYear()) {
                onDateChange(newStartDate?.toISOString(), localEndDate)
                setLocalStartDate(newStartDate?.toISOString())
              }
            }}
            data-testid="date-range-picker-start"
          />
        </FormControl>
        <Typography marginTop="8px" variant="body1">
          {' '}
          —{' '}
        </Typography>
        <FormControl style={{ minWidth: '80px' }} variant="outlined" margin="normal">
          <InputLabel
            sx={{ background: colors.white, padding: '0 6px', color: '#00000099' }}
            data-testid="shortlist-filter-combination-label"
            shrink
          >
            {t(translations.END)}
          </InputLabel>
          <DatePicker
            sx={{ width: '145px' }}
            slotProps={{
              openPickerButton: {
                sx: { marginRight: 0 },
                size: 'small',
              },
            }}
            format="DD/MM/YYYY"
            value={end ? dayjs(end) : null}
            onChange={newEndDate => {
              if (newEndDate?.isValid() && newEndDate.year() >= MINIMUM_DATE_RANGE_BOUND_DATE.getFullYear()) {
                onDateChange(localStartDate, newEndDate.endOf('day').toISOString())
                setLocalEndDate(newEndDate?.toISOString())
              }
            }}
            data-testid="date-range-picker-end"
          />
        </FormControl>
      </Box>
    </LocalizationProvider>
  )
}
